
import platform from '../util/platform';

// Every Environment except IE9 considers SWF objects focusable
var result = !platform.is.IE9;

export default function () {
  return result;
}
//# sourceMappingURL=focus-object-swf.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ally.js/esm/supports/focus-object-swf.js
// module id = 192
// module chunks = 0 1